// ─────────────────────────────────────────────────────────────────────────────
// Virtual category groups — merge several real category slugs into a single
// tile in the storefront category bar (e.g. "Smart Home" = Sensors + Switches).
// Purely presentational: no backend Category document is created for these.
// A group only appears once at least one of its `memberSlugs` is present in
// the live (product-having) category list — so "Smart Home" simply won't
// show until a matching category (e.g. a future "switch" category) exists.
// ─────────────────────────────────────────────────────────────────────────────

export const CATEGORY_GROUPS = [
  {
    slug:        'smart-home',
    title:       'Smart Home',
    icon:        'pi pi-home',
    memberSlugs: ['sensors', 'switch', 'switches', 'smart-switch', 'smart-switches'],
    // Fixed slot in the category bar (0-based, counting "All" as slot 0) —
    // always the 2nd tile, regardless of where product-count sorting would
    // otherwise place it.
    pinPosition: 1,
  },
];

// Merge any categories matching a group's memberSlugs into one synthetic
// tile, inserted at the position of the first matched member, then pinned
// to its configured fixed slot (if any).
export const groupCategories = (categories) => {
  let result = [...categories];
  for (const group of CATEGORY_GROUPS) {
    const memberIdx = [];
    result.forEach((c, i) => { if (group.memberSlugs.includes(c.slug)) memberIdx.push(i); });
    if (memberIdx.length === 0) continue;

    const members = memberIdx.map((i) => result[i]);
    result = result.filter((_, i) => !memberIdx.includes(i));
    result.splice(memberIdx[0], 0, {
      _id:      group.slug,
      title:    group.title,
      slug:     group.slug,
      isActive: true,
      isGroup:  true,
      memberSlugs: members.map((m) => m.slug),
    });
  }

  for (const group of CATEGORY_GROUPS) {
    if (group.pinPosition == null) continue;
    const idx = result.findIndex((c) => c.slug === group.slug);
    if (idx === -1) continue;
    const [tile] = result.splice(idx, 1);
    result.splice(Math.min(group.pinPosition, result.length), 0, tile);
  }

  return result;
};
